<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router'
import { useModalStore } from '@/stores/modal.js';

// Stores
const modalStore = useModalStore();

// I18n
const { t } = useI18n();

// Variables
const isLoading = ref(true);
const isVerificationSuccessful = ref(false);
const router = useRouter();
const code = ref("");

const handleVerification = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const verifyValue = urlParams.get('verify');

    fetch(`${import.meta.env.VITE_BACKEND_URL}/api/v2/servicechek/users/verify`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ code: code.value, verify: verifyValue })
    })
    .then(response => {
        if (response.ok) {
            modalStore.setModal(modalStore.modalTypeConstants.LOGIN);
            router.push({ path: '/' });
            isVerificationSuccessful.value = true;
        } else {
            isLoading.value = false;
        }
    })
    .catch(error => {
        console.error('Error:', error);
        isLoading.value = false;
    });
};
</script>

<template>
    <div class="mt-10 mb-10 flex justify-center items-center w-full">
        <div class="max-w-fit">
            <div class="mb-2">
                <label for="code" class="block text-gray-600 font-semibold">{{ t('verification.enter_verification_code') }}</label>
                <input type="text" id="code" name="code" v-model="code" class="w-full mt-1 p-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-purple-300" :placeholder="t('verification.verification_code_form_placeholder')">
            </div>
            <button type="button" @click="handleVerification" class="me-0 float-end focus:outline-none text-white submit-button hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800">Submit</button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/views/activation/activate';
</style>
